/**
 * Client gameplay tunables. One place to turn the knobs the renderer bakes
 * into behaviour — walking speed first among them.
 */

/** How fast the player walks, metres per second. */
export const WALK_SPEED_MPS = 6;

/** The avatar: blue capsule body, beige head, white ground ring. */
export const PLAYER_BODY_COLOR = 0x3b82f6;
export const PLAYER_HEAD_COLOR = 0xe8d5b5;
export const PLAYER_RING_COLOR = 0xffffff;

/** Walking is finished when the avatar is this close to the target. */
export const ARRIVE_EPS_M = 0.4;

/** The path line and pulsing destination ring while a walk is under way. */
export const PATH_COLOR = 0x35d07f;
export const TARGET_RING_RADIUS_M = 1.6;

/** Whether the camera glides along with the walking avatar. */
export const CAMERA_FOLLOW = true;

/** The avatar is pointless past this camera distance and hides itself. */
export const PLAYER_VISIBLE_DIST = 2_500;
